export const getOnboardSteps = (t: (text: string) => string, itemId: string, onBoardStart: boolean) => {
  if (!onBoardStart) return [];
  return [
    {
      disableBeacon: true,
      target: 'redirect-4',
      data: {
        navigateBefore: `ai/${itemId}`,
        previousItemIndex: 6,
      },
    },
    {
      target: '#tourStep-19',
      content: t(
        'An overview of your Waites-monitored equipment is also available in the Sensor Overview section, where each square represents a sensor installed on your equipment.',
      ),
      placement: 'bottom',
    },
    {
      target: 'redirect-5',
      data: {
        navigateAfter: 'reports',
      },
    },
  ];
};
